<script setup lang="ts">
const route = useRoute();

function isSeActive(): boolean {
  if(route.path === '/shipexkurs' || route.path.startsWith('/shipexkurs/ships')) return true;
  return false;
}

function isCompareActive(): boolean {
  return route.path.startsWith('/shipexkurs/vergleich');
}


const items = computed(() => [[{
  label: 'Shipexkurs',
  icon: 'i-lucide-house',
  to: '/shipexkurs',
  active: isSeActive()
}, {
  label: 'Schiffsvergleich',
  icon: 'i-lucide-scale',
  to: '/shipexkurs/vergleich',
  active: isCompareActive()
}]])


</script>

<template>
  <div class="min-h-screen bg-woodsmoke-950">
     <UDashboardGroup>
      <UDashboardSidebar collapsible resizable :ui="{ header: 'h-fit pt-4 pb-2 mb-0', body: 'pt-0', footer: 'border-t border-default' }">
          <template #header>
            <NuxtImg src="ffe7c93d-6f9e-4335-aae7-8a3db4551b95" class="w-full mx-auto max-h-25 object-cover h-auto max-w-42.5" />
          </template>

          <template #default="{ collapsed }">
            <CommandPaletteButton
              :collapsed="collapsed"
              class="mb-3"
            />

            <UNavigationMenu
              :collapsed="collapsed"
              :items="items[0]"
              orientation="vertical"
            />
          </template>

          <template #footer="{ collapsed }">
            <a href="/" class="not-prose">
              <UButton variant="subtle" icon="i-lucide-home" :label="!collapsed ? 'Homepage' : undefined" />
            </a>
          </template>
        </UDashboardSidebar>

      <UDashboardPanel
        id="shipexkurs-content"
        :ui="{ body: 'p-0 sm:p-0' }"
      >
        <template #body>
          <div class="mx-auto w-full max-w-[2200px]">
            <slot />
          </div>
        </template>
      </UDashboardPanel>
     </UDashboardGroup>
    <!-- <aside class="fixed inset-y-0 left-0 z-20 flex w-60 flex-col border-r border-white/10 bg-woodsmoke-950 px-3 py-4">
      <NuxtLink to="/" class="mb-8 flex items-center gap-2 px-2">
        <UIcon name="i-lucide-radar" class="size-6 text-industrial-400" />
        <span class="text-sm font-bold tracking-widest text-white">ARISCORP</span>
      </NuxtLink>

      <nav class="flex-1 space-y-0.5">
        <NuxtLink
          v-for="item in navItems"
          :key="item.to"
          :to="item.to"
          class="flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors"
          :class="isActive(item.to) ? 'bg-white/10 text-white' : 'text-neutral-400 hover:bg-white/5 hover:text-white'"
        >
          <UIcon :name="item.icon" class="size-4" />
          {{ item.label }}
        </NuxtLink>

        <div
          v-for="item in comingSoonItems"
          :key="item.label"
          title="Bald verfügbar"
          class="flex cursor-not-allowed items-center gap-3 rounded-md px-3 py-2 text-sm text-neutral-600"
        >
          <UIcon :name="item.icon" class="size-4" />
          {{ item.label }}
        </div>
      </nav>
    </aside> -->


  </div>
</template>
